import { Injectable } from '@angular/core';
import { CustomerProductPrice, PriceConfigService, Product, Price } from 'gung-standard';
import { Observable, map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HlDisplayPriceConfigService extends PriceConfigService {
  protected override getQuantityForStaffedDisplay(overrideQty: number, quantity: number) {
    return quantity || overrideQty || 1;
  }

  protected createStaffedHTML(
    priceStaffedString: string,
    discountPercent: number,
    priceString: string,
    displayOnlyPrice?: boolean,
    product?: Product
  ) {
    if (displayOnlyPrice) {
      return `<span>${priceStaffedString}</span>`;
    } else if (discountPercent !== 0) {
      return `<div>${priceStaffedString} <small>(-${discountPercent.toFixed(
        2
      )}%)</small><span class='text-muted float-right'>${priceString}</span></div>`;
    } else {
      return `<span>${priceString}</span>`;
    }
  }
}
